import { gql } from '@apollo/client';

const GET_USER = gql`
  query getUser($groupId: Int! $userId: Int!) {
    user {
      get(groupId: $groupId, userId: $userId) {
        firstName: firstname
        lastName: lastname
        credential {
          email
        }
        id
      }
    }
  }
`;

export { GET_USER };
